class vehicleSelection {
  constructor() {
    this.init();
  }

  checkCurrentSelection() {
    setTimeout(() => {
      let myInterval = setInterval(() => {
        if (easysearch != undefined && easysearch != null) {
          if (easysearch.preSelect != "") {
            var vehicleNameElementsDesktop = document.querySelectorAll('[data-desktop-vehicle-name]');
            document.querySelector('[data_selected_vehicle]').classList.remove('d-none');
            var vehicleName = `${easysearch.preSelect[0]} ${easysearch.preSelect[1]} ${easysearch.preSelect[2]}`;
            document.querySelector('#selectedVehicle').innerHTML = vehicleName;  
            if (vehicleName != null) {
              document.title = vehicleName + ' | Springrates.com'; 
            }
            if (window.screen.width >= 992) {
              document.querySelector('.desktop-vehicle-selection[data_vehicle_selection]').classList.add('d-lg-none');
            } else {
              document.querySelector('.mobile-vehicle-selection[data_vehicle_selection]').classList.add('d-none');
            }
            if (vehicleNameElementsDesktop.length > 0) {
              vehicleNameElementsDesktop.forEach((item) => {
                item.innerHTML = vehicleName.slice(0, 13) + '...';
              })
            }
            clearInterval(myInterval);
          }
        }
      }, 1000)
    }, 2000)
  }

  init() {
    this.checkCurrentSelection();
  }
}
new vehicleSelection();